// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__K_8XU","header":"styles_header__0kwxg","sectionsGroup":"styles_sectionsGroup__bk5t_","gap":"styles_gap___B1TB"};